// extracted by mini-css-extract-plugin
module.exports = {"h2":"H2_h2__X81M5"};